import { render, staticRenderFns } from "./noticeDialog.vue?vue&type=template&id=5e00c718&scoped=true&"
import script from "./noticeDialog.vue?vue&type=script&lang=js&"
export * from "./noticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./noticeDialog.vue?vue&type=style&index=0&id=5e00c718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e00c718",
  null
  
)

export default component.exports